<template>
  <div id="Home" v-cloak>
    <!-- 头部 -->
    <Header />
    <!-- banner   -->
    <div class="banner">
      <el-carousel :interval="3000" :height="bannerHeight">
        <el-carousel-item v-for="(item,idx) in imgArr" :key="idx+item">
         <a :href="item.link" target="_blank"> <img class="banner-img" :src="item.imgSrc" :alt="item.imgName" /></a>
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- news -->
    <div class="news">
      <div class="newsbg1"></div>
      <div class="newsbg2"></div>
      <div class="news-content clearfix">
        <div class="img lft">
          <el-carousel :interval="2000" arrow="never" height="400px">
            <el-carousel-item v-for="(item,index) in imgNewsArr" :key="(item+index)">
              <a :href="item.imgUrl" target="_blank">
                <img :src="item.imgSrc" class="news-imgs" :alt="item.imgName" />
              </a>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="news-list rgt">
          <el-tabs v-model="activeName">
            <el-tab-pane label="新闻动态" name="first">
              <ul class="news-ul">
                <li v-for="(item,i) in newsArr" :key="(item+i)">
                  <span class="news-title">{{item.title}}</span>
                  <span class="text">{{item.text}}</span>
                  <span class="details">
                    <router-link :to="'/DynamicsDetails/'+item.url" target="_blank">
                      <span title="详情">详情&gt;&gt;</span>
                    </router-link>
                  </span>
                </li>
              </ul>
              <div class="more" @click="toInstitutionalDynamics(1)">更多&gt;&gt;
                <!-- <router-link to="/InstitutionalDynamics">更多&gt;&gt;</router-link> -->
              </div>
            </el-tab-pane>
            <el-tab-pane label="行业资讯" name="second">
              <ul class="news-ul">
                <li v-for="(item,i) in informationArr" :key="(item+i)">
                  <span class="news-title">{{item.title}}</span>
                  <span class="text">{{item.text}}</span>
                  <span class="details">
                    <router-link :to="'/DynamicsDetails/'+item.url"  target="_blank">
                      <span title="详情">详情&gt;&gt;</span>
                    </router-link>
                  </span>
                </li>
              </ul>
              <div class="more" @click="toInstitutionalDynamics(2)">更多&gt;&gt;
                <!-- <router-link to="/InstitutionalDynamics">更多&gt;&gt;</router-link> -->
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
      <!-- activities -->
      <div class="activities">
        <div class="acitve-title">近期活动</div>
        <div class="acitve-other">
          <span class="en-text">Recent activities</span>
        </div>
        <el-carousel class="card-list" type="card" height="270px">
          <el-carousel-item v-for="(item,i) in cardArr" :key="(item+i)">
            <a :href="item.Url" target="_blank">
              <img :src="item.imgSrc" :alt="item.title" />
            </a>
            <div class="words">{{item.activeName}}</div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <!-- ebsiness -->
    <div class="ebsiness" id="ebsiness">
      <div class="ebsiness-content">
        <div id="advert" class="advert">
          <div class="bg1">
            <div>
              <span class="icon01"></span>
            </div>
          </div>
          <div class="bg2">
            <div>
              <span class="icon08"></span>
              <span class="icon09"></span>
              <span class="icon10"></span>
            </div>
          </div>
          <div class="bg3">
            <div>
              <span class="icon11"></span>
              <span class="icon12"></span>
            </div>
          </div>
          <div class="content">
            <img
              :src="require('@/assets/images/Home/icons/business-new-02.png')"
              alt
              style="vertical-align: middle;"
            />
          </div>
        </div>
        <transition
          enter-active-class="animated bounceInLeft"
          leave-active-class="animated bounceOutLeft"
        >
          <div v-if="flag" class="ebsiness-title t1">
            众信签
            <div class="etrust">
              <img :src="require('@/assets/images/Home/icons/05.png')" alt />
            </div>
            <div class="details-d t1-details animated fadeInDown">
              <div class="details-title">众信签</div>
              <div
                class="details-content"
              >众信签能为广大用户提供身份认证、合同起草、合同签署、合同管理、存证固证及云上仲裁等一站式服务，告别纸质合同烦恼，让签约更高效。<a href="https://www.ebssign.com/" target="_blank">更多>></a></div>
            </div>
          </div>
        </transition>
        <transition
          enter-active-class="animated bounceInLeft"
          leave-active-class="animated bounceOutLeft"
        >
          <div v-if="flag" class="ebsiness-title t2">
            在线纠纷解决
            <div class="etrust">
              <img :src="require('@/assets/images/Home/icons/06.png')" alt />
            </div>
            <div class="details-d t2-details animated fadeInDown">
              <div class="details-title">在线纠纷解决</div>
              <div
                class="details-content"
              >以“开放、多元、中立、可信”的第三方权威在线纠纷解决服务平台为支撑，整合社会各界解纷资源，为广大用户提供以咨询、纠纷调解、调仲对接、纠纷信用评价等服务为核心的“互联网+”多元化纠纷解决服务体系。让纠纷当事人“足不出户”即轻松可化解矛盾纠纷。</div>
            </div>
          </div>
        </transition>
        <transition
          enter-active-class="animated bounceInLeft"
          leave-active-class="animated bounceOutLeft"
        >
          <div v-if="flag" class="ebsiness-title t3">
            智信+
            <div class="etrust">
              <img :src="require('@/assets/images/Home/icons/07.png')" alt />
            </div>
            <div class="details-d t3-details animated fadeInDown">
              <div class="details-title">智信+</div>
              <div
                class="details-content"
              >以智慧信用为基础，以法规标准为依据，结合大数据挖掘与分析等技术，构建起的集信用画像、信用预警、信用监管、信用修复、信用服务等监管与服务一体化的智慧信用平台，在智慧政务、产业发展等领域开展应用，营造良好的社会诚信环境，促进社会和谐健康发展。</div>
            </div>
          </div>
        </transition>
        <transition
          enter-active-class="animated bounceInRight"
          leave-active-class="animated bounceOutRight"
        >
          <div v-if="flag" class="ebsiness-title t4">
            <div class="etrust">
              <img :src="require('@/assets/images/Home/icons/01.png')" alt />
            </div>主体身份验证
            <div class="details-d t4-details animated fadeInDown">
              <div class="details-title">主体身份验证服务</div>
              <div
                class="details-content"
              >为企事业单位、个体户、社会团体等提供身份资质、网站与主体虚实对应、主体规模与实力、平台内容等权威公正的认证与审核评估服务，保障主体可信。内容包括微信公众号系列审核、工商网监电子标识、众信示范企业认证等。</div>
            </div>
          </div>
        </transition>
        <transition
          enter-active-class="animated bounceInRight"
          leave-active-class="animated bounceOutRight"
        >
          <div v-if="flag" class="ebsiness-title t5">
            <div class="etrust">
              <img :src="require('@/assets/images/Home/icons/02.png')" alt />
            </div>国际跨境贸易核验服务
            <div class="details-d t5-details animated fadeInDown">
              <div class="details-title">国际跨境贸易核验服务</div>
              <div
                class="details-content"
              >联合全球知名权威检测验证机构，为跨境贸易企业提供动态实名实地、深度验厂的AI智慧联合认证核验服务，多语言、多维度展示企业在全球范围内的商业信誉与综合实力，通过搭载国际通用的跨境贸易认证服务，全程赋能一带一路，促进贸易便利化，提高企业国际竞争力。</div>
            </div>
          </div>
        </transition>
        <transition
          enter-active-class="animated bounceInRight"
          leave-active-class="animated bounceOutRight"
        >
          <div v-if="flag" class="ebsiness-title t6">
            <div class="etrust">
              <img :src="require('@/assets/images/Home/icons/03.png')" alt />
            </div>品信通防伪溯源
            <div class="details-d t6-details animated fadeInDown">
              <div class="details-title">品信通防伪溯源</div>
              <div
                class="details-content"
              >以品牌防伪、品质溯源、智慧营销、数据魔方等功能为核心，可根据用户对防伪、溯源、营销、大数据应用的不同需求，并结合NFC、区块链、电信NB-IOT等领先技术，提供专业定制化防伪溯源解决方案。</div>
            </div>
          </div>
        </transition>
        <transition
          enter-active-class="animated bounceInRight"
          leave-active-class="animated bounceOutRight"
        >
          <div v-if="flag" class="ebsiness-title t7">
            <div class="etrust">
              <img :src="require('@/assets/images/Home/icons/04.png')" alt />
            </div>知识产权
            <div class="details-d t7-details animated fadeInDown">
              <div class="details-title">知识产权</div>
              <div
                class="details-content"
              >以专利检索、风险预警、知识产权电子数据存证、知识产权地图、维权保护、专利价值评估为特色服务，为知识产权服务机构与企业建立更广泛、更高效的服务连接。</div>
            </div>
          </div>
        </transition>
      </div>
    </div>
    <!-- company -->
    <div class="company">
      <div class="companybg1"></div>
      <div class="companybg2"></div>
      <div class="company-content clearfix">
        <div class="profile clearfix">
          <div class="flt">
            <a href>
              <img :src="require('@/assets/images/Home/bg/news0.png')" alt />
            </a>
          </div>
          <div class="rgt">
            <div class="status-title">中心简介</div>
            <div class="en-title">Company profile</div>
            <div class="word">
              深圳市众信电子商务交易保障促进中心（ 简称“ 众信中心” ）是承担电子商务可信交易环境建设的第三方服务机构。根据目前电子商务市场现状，总结国内企业和第三方机构的成功做法，借鉴国外信用体系建设的先进经验，面向企业提供主体身份在线查验、产品信息在线查验、交易凭证查验、市场基础数据服务等服务，开展电子商务可信交易环境建设宣传与推广。
              <router-link class="more" to="/AboutUs">更多&gt;&gt;</router-link>
            </div>
          </div>
        </div>
        <div class="status clearfix">
          <div class="flt">
            <div class="status-title">荣誉身份展示</div>
            <div class="en-title">Honorary status</div>
            <div class="clearfix">
              <ul class="list">
                <li>中国消费品质量安全促进会电子商务诚信建设工作委员会秘书处</li>
                <li>中国报关协会跨境分会理事单位</li>
                <li>WTA（国际信赖标章联盟）轮值主席（2016-2017年）</li>
                <li>深圳市深圳标准促进会副理事长单位</li>
                <li>众信电子商务在线纠纷人民调解委员会</li>
                <li>粤港澳联合争议解决中心联合发起单位</li>
                <li>跨境圈子-珊瑚荟发起单位</li>
                <li>信用智库发起单位</li>
              </ul>
            </div>
          </div>
          <div class="rgt">
            <a href>
              <img :src="require('@/assets/images/Home/bg/news2.png')" alt />
            </a>
          </div>
        </div>
      </div>
    </div>
    <!-- partner -->
    <div class="partner">
      <div class="img-list">
        <div class="partner-title">合作伙伴</div>
        <div class="partner-other">
          <span class="en-text">Cooperative partner</span>
        </div>
        <ul class="clearfix">
          <li>
            <img :src="require('@/assets/images/Home/partnerlogo/1688.jpg')" alt />
          </li>
          <li>
            <img :src="require('@/assets/images/Home/partnerlogo/tencent.jpg')" alt />
          </li>
          <li>
            <img :src="require('@/assets/images/Home/partnerlogo/baidu.jpg')" alt />
          </li>
          <li>
            <img :src="require('@/assets/images/Home/partnerlogo/taobao.jpg')" alt />
          </li>
          <li>
            <img :src="require('@/assets/images/Home/partnerlogo/jdys.jpg')" alt />
          </li>
          <li>
            <img :src="require('@/assets/images/Home/partnerlogo/tengbang.jpg')" alt />
          </li>
          <li>
            <img :src="require('@/assets/images/Home/partnerlogo/baiteng.jpg')" alt />
          </li>
        </ul>
        <ul class="clearfix">
          <li>
            <img :src="require('@/assets/images/Home/partnerlogo/ebay.jpg')" alt />
          </li>
          <li>
            <img :src="require('@/assets/images/Home/partnerlogo/tianhong.jpg')" alt />
          </li>
          <li>
            <img :src="require('@/assets/images/Home/partnerlogo/szwyh.jpg')" alt />
          </li>
          <li>
            <img :src="require('@/assets/images/Home/partnerlogo/szzljy.jpg')" alt />
          </li>
          <li>
            <img :src="require('@/assets/images/Home/partnerlogo/hnc.jpg')" alt />
          </li>
          <li>
            <img :src="require('@/assets/images/Home/partnerlogo/mybk.jpg')" alt />
          </li>
          <li>
            <img :src="require('@/assets/images/Home/partnerlogo/szjw.jpg')" alt />
          </li>
        </ul>
        <ul class="clearfix">
          <li>
            <img :src="require('@/assets/images/Home/partnerlogo/zgjrrz.jpg')" alt />
          </li>
          <li>
            <img :src="require('@/assets/images/Home/partnerlogo/szgy.jpg')" alt />
          </li>
          <li>
            <img :src="require('@/assets/images/Home/partnerlogo/szkjsw.jpg')" alt />
          </li>
          <li>
            <img :src="require('@/assets/images/Home/partnerlogo/szxfz.jpg')" alt />
          </li>
          <!-- <li>
            <img :src="require('@/assets/images/Home/partnerlogo/hlct.jpg')" alt />
          </li> -->
          <li>
            <img :src="require('@/assets/images/Home/partnerlogo/gdshd.jpg')" alt />
          </li>
          <li>
            <img :src="require('@/assets/images/Home/partnerlogo/hqdzw.jpg')" alt />
          </li>
        </ul>
      </div>
    </div>
    <!--浮窗-->
      <!-- <div class="Side-ad">
          <a href="https://www.ebssign.com/" target="_blank"><img src="@/assets/images/Home/bg/sidead.png"></a>
      </div> -->
    <!-- footer -->
    <Footer />
  </div>
</template>

<script>
import Header from "./components/Header.vue";
import Footer from "./components/Footer.vue";
import {GetPage,GetHomeImages,GetActivityList} from './utils/http'
export default {
  name: "Home",
  components: {
    Header,
    Footer
  },
  data() {
    return {
      flag: false,
      activeName: "first",
      search1: "",
      search2: "",
      //轮播banner图
      imgArr: [
        {
          imgSrc: require("@/assets/images/Home/bg/banner01.jpg")
        },
        {
          imgSrc: require("@/assets/images/Home/bg/banner02.jpg")
        },
        {
          imgSrc: require("@/assets/images/Home/bg/banner03.jpg")
        },
        {
          imgSrc: require("@/assets/images/Home/bg/banner04.jpg")
        },
        {
          imgSrc: require("@/assets/images/Home/bg/banner05.jpg"),
          link:"https://www.globalodr.com/"
        }
      ],
      //新闻动态
      newsArr: [
        {
          title: "深圳市市监局召开网络市场监管执法效能提升工作思路汇报研讨会",
          text:
            "4月22日，深圳市市场监管局网监处牵头组织召开网络市场监管执法效能提升工作思路汇报研讨会，深圳市市场监管局领导李平同志参加。会议由网监处处长周文主持，法规处、指挥处、智慧处、网监处、稽查局各业务处、投诉举报中心、标准院、众信中心相关负责同志参会。",
          url:
            "https://www.ebs.org.cn/DynamicsDetails/06e82902-60c2-4021-be55-14eac23af02a"
        }
      ],
      //行业资讯
      informationArr: [],
      //首页新闻图片
      imgNewsArr: [],
      //轮播卡
      cardArr: [],
      // 图片父容器高度
      bannerHeight: "1000",
      // 浏览器宽度
      screenWidth: 0,
      //默认首页大图，当接口异常时展示
      defaultHomeImg: [
        {
          imgSrc: require("@/assets/images/Home/default/news/1.jpg"),
          imgName: "2019国际网络营商环境建设论坛暨第二届深圳互联网诚信大会",
          imgUrl:
            "https://www.ebs.org.cn/DynamicsDetails/01323a5d-faeb-473d-b9a0-b153cbb344c0"
        },
        {
          imgSrc: require("@/assets/images/Home/default/news/2.jpg"),
          imgName: "2019第二届中国（深圳）出口跨境电商大会",
          imgUrl:
            "https://www.ebs.org.cn/DynamicsDetails/ae3819fc-7da7-475f-a0fb-350896087cb4"
        },
        {
          imgSrc: require("@/assets/images/Home/default/news/3.jpg"),
          imgName: "众信中心亮相第十六届中博会跨境电商展，引领行业信任新风尚",
          imgUrl:
            "https://www.ebs.org.cn/DynamicsDetails/fafd0c05-8a3c-4db8-84bc-e7f6b9d3329b"
        },
        {
          imgSrc: require("@/assets/images/Home/default/news/4.jpg"),
          imgName: "2019深圳互联网3·15诚信大会圆满举行",
          imgUrl:
            "https://www.ebs.org.cn/DynamicsDetails/51b7f834-c5ff-4d4b-8100-757df8ddf7d5"
        },
        {
          imgSrc: require("@/assets/images/Home/default/news/5.jpg"),
          imgName: "2019台州跨境电商产业合作发展推介会顺利举行",
          imgUrl:
            "https://www.ebs.org.cn/DynamicsDetails/5dd54d1c-a8ba-48c5-868a-759afb748845"
        }
      ],
      //默认活动模块图片
      defaultActivity: [
        {
          imgSrc: require("@/assets/images/Home/default/activity/1.jpg"),
          title:
            "2019国际网络营商环境建设论坛暨第二届深圳互联网诚信大会隆重举行",
          activeName:
            "2019国际网络营商环境建设论坛暨第二届深圳互联网诚信大会隆重举行",
          Url: "http://gjcxdh.ebs.org.cn/"
        },
        {
          imgSrc: require("@/assets/images/Home/default/activity/2.jpg"),
          title: "2019第二届中国（深圳）出口跨境电商大会隆重举行",
          activeName: "2019第二届中国（深圳）出口跨境电商大会隆重举行",
          Url: "http://kjdh.ebs.org.cn/"
        },
        {
          imgSrc: require("@/assets/images/Home/default/activity/3.jpg"),
          title: "2019深圳互联网3·15诚信大会圆满举行",
          activeName: "2019深圳互联网3·15诚信大会圆满举行",
          Url:
            "https://www.ebs.org.cn/DynamicsDetails/51b7f834-c5ff-4d4b-8100-757df8ddf7d5"
        }
      ]
    };
  },
  methods: {
    setSize: function() {
      // 通过浏览器宽度(图片宽度)计算高度
      this.bannerHeight = (580 / 1920) * this.screenWidth + "px";
    },
    scroll: function() {
      //监听页面滚动事件
      var that = this;
      var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop > 800 && scrollTop < 2000) {
        that.flag = true;
      } else {
        that.flag = false;
      }
    },
    toInstitutionalDynamics(type){
      var routerHref = this.$router.resolve({name:'InstitutionalDynamics',params:{type:type}})
       window.open(routerHref .href, '_blank');
    },
    //获取新闻动态列表
    GetNewsList(type){
      var _this = this;
      GetPage(type)
        .then(res=> {
          if (res.data.ErroeMsg === "查询正常") {
            var list = [];
            for (var i = 0; i < res.data.InfoRelModel.length; i++) {
              var news = {
                title: res.data.InfoRelModel[i].Title,
                text: res.data.InfoRelModel[i].Introduction,
                url: res.data.InfoRelModel[i].InfoID
              };
              list.push(news);
            }
            if (type === 2) {
              _this.informationArr = list;
            } else {
              _this.newsArr = list;
            }
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    //获取首页新闻大图
    GetHomeImage(){
      var _this = this;
      GetHomeImages().then(function(res) {
          if (res.data.success && res.data.list.length > 0) {
            for (var i = 0; i < res.data.list.length; i++) {
              var image = {
                imgSrc: res.data.list[i].ImageUrl,
                imgName: res.data.list[i].ImageIntroduce,
                imgUrl: "/DynamicsDetails/" + res.data.list[i].NewId
              };
              _this.imgNewsArr.push(image);
            }
          } else {
            _this.imgNewsArr = _this.defaultHomeImg;
          }
        })
        .catch(function(error) {
          console.log(error);
          _this.imgNewsArr = _this.defaultHomeImg;
        });
    },

    //获取活动列表
    GetActivityList: function() {
      var _this = this;
      GetActivityList().then(function(res) {
          if (res.data.success && res.data.list.length > 0) {
            for (var i = 0; i < res.data.list.length; i++) {
              var activity = {
                imgSrc: res.data.list[i].ImageUrl,
                title: res.data.list[i].Title,
                activeName: res.data.list[i].Content,
                Url: res.data.list[i].ActivityLink.replace("/EbsNews/Detail","/DynamicsDetails") 
              };
              _this.cardArr.push(activity);
            }
          } else {
            _this.cardArr = _this.defaultActivity;
          }
        })
        .catch(function(error) {
          console.log(error);
          _this.cardArr = _this.defaultActivity;
        });
    },
    changeSize: function() {
      var that = this;
      that.screenWidth = window.innerWidth;
      that.setSize();
    }
  },
  created: function() {
    var that = this;
    window.addEventListener("scroll", that.scroll);
    that.GetNewsList(1);
    that.GetNewsList(2);
    that.GetHomeImage();
    that.GetActivityList();
  },
  mounted: function() {
    var that = this;
    window.addEventListener("scroll", that.scroll);
    // 首次加载时,需要调用一次
    that.screenWidth = window.innerWidth;
    that.setSize();
    // 窗口大小发生改变时,调用一次
    //        window.onresize = () => {
    //            that.screenWidth = window.innerWidth;
    //            that.setSize();
    //        }
    window.onresize = that.changeSize();
  }
};
</script>

<style lang="less" scoped>
#Home {
  /deep/.menu {
    background-color: transparent;
    .el-menu-demo {
      li {
        color: #fff;
        .el-submenu__title {
          color: #fff;
          &:hover {
            background-color: rgba(0, 0, 0, 0.5);
          }
        }
        a {
          color: #fff;
        }
        &:hover {
          background-color: rgba(0, 0, 0, 0.5);
        }
      }
    }
  }
  .banner {
    position: relative;
    width: 100%;
    z-index: 1;
    .banner-img {
      /*设置图片宽度和浏览器宽度一致*/
      width: 100%;
      height: inherit;
    }
  }
  /* news */
  .news {
    width: 100%;
    position: relative;
    .newsbg1 {
      width: 346px;
      height: 584px;
      position: absolute;
      left: 0;
      top: 10%;
      background: url("./assets/images/Home/bg/line-01.png") no-repeat;
    }
    .newsbg2 {
      width: 346px;
      height: 584px;
      position: absolute;
      right: 0;
      top: 10%;
      background: url("./assets/images/Home/bg/line-02.png") no-repeat;
    }
    .news-content {
      width: 1040px;
      margin: 40px auto;
      .img {
        width: 695px;
        margin-right: 30px;
        text-align: center;
      }
      .news-list {
        width: 315px;
        /deep/ .el-tabs__header {
          margin-bottom: 0;
        }
        .news-ul {
          margin-top: 20px;
          li {
            line-height: 20px;
            margin-bottom: 15px;
            overflow: hidden;
            .news-title {
              display: block;
              font-weight: 700;
              width: 246px;
              display: inline-block;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .text {
              text-indent: 2em;
              color: #999;
              width: 246px;
              display: inline-block;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .details {
              float: right;
              a {
                display: inline-block;
                text-align: right;
                span {
                  color: #409eff;
                  cursor: pointer;
                  margin-left: 18px;
                }
              }
            }
          }
        }
      }
      .more {
        text-align: right;
        cursor: pointer;
      }
    }
  }
  /* activities */
  .activities {
    width: 1040px;
    margin: 0 auto;
    .acitve-title {
      text-align: center;
      margin: 15px auto;
      font-size: 30px;
      font-weight: 900;
    }
    .acitve-other {
      position: relative;
      width: 400px;
      margin: 40px auto;
      border-bottom: 2px solid #ccc;
      .en-text {
        position: absolute;
        top: -24px;
        left: 90px;
        width: 220px;
        background: #fff;
        padding: 10px;
        font-size: 24px;
        text-align: center;
      }
    }
    .card-list {
      position: relative;
      img {
        width: 100%;
      }
      .words {
        background: rgba(0, 0, 0, 0.6);
        padding: 3px 0;
        position: absolute;
        bottom: 10px;
        left: 0;
        right: 0;
        color: #fff;
        text-align: center;
      }
    }
  }
  /* ebsiness */
  .ebsiness {
    width: 100%;
    height: 580px;
    padding-top: 100px;
    background: url("./assets/images/Home/bg/bg03-03.png") no-repeat;
    .ebsiness-content {
      position: relative;
      margin: 0 auto;
      width: 1040px;
      height: 465px;
      background-position: center;
      .etrust {
        display: inline-block;
        vertical-align: middle;
        margin: 0 10px;
      }
      .t1 {
        position: absolute;
        left: 200px;
        top: -20px;
        .t1-details {
          margin-left: -60px;
        }
        &:hover {
          .t1-details {
            display: block;
          }
        }
      }
      .t2 {
        position: absolute;
        left: 90px;
        top: 170px;
        .t2-details {
          margin-left: -60px;
        }
        &:hover {
          .t2-details {
            display: block;
          }
        }
      }
      .t3 {
        position: absolute;
        left: 180px;
        top: 365px;
        .t3-details {
          margin-left: -60px;
        }
        &:hover {
          .t3-details {
            display: block;
          }
        }
      }
      .t4 {
        position: absolute;
        left: 685px;
        top: -20px;
        .t4-details {
          margin-left: 40px;
        }
        &:hover {
          .t4-details {
            display: block;
          }
        }
      }
      .t5 {
        position: absolute;
        left: 740px;
        top: 170px;
        .t5-details {
          margin-left: 40px;
        }
        &:hover {
          .t5-details {
            display: block;
          }
        }
      }
      .t6 {
        position: absolute;
        left: 720px;
        top: 365px;
        .t6-details {
          margin-left: 40px;
        }
        &:hover {
          .t6-details {
            display: block;
          }
        }
      }
      .t7 {
        position: absolute;
        left: 450px;
        top: 455px;
        .t7-details {
          margin-left: 40px;
        }
        &:hover {
          .t7-details {
            display: block;
          }
        }
      }
      .ebsiness-title {
        color: #036eb8;
        font-size: 18px;
        .details-d {
          display: none;
          margin-top: 5px;
          position: relative;
          z-index: 10;
          width: 265px;
          .details-title {
            border-radius: 10px;
            padding: 5px 10px;
            background: #036eb8;
            text-align: center;
            color: #fff;
            font-size: 18px;
            z-index: 20;
          }
          .details-content {
            line-height: 25px;
            border-radius: 0 0 10px 10px;
            border: 1px solid #036eb8;
            font-size: 14px;
            background: rgba(218, 241, 255, 0.7);
            padding: 20px 10px 10px;
            position: absolute;
            top: 20px;
            left: 0;
            width: 100%;
            z-index: -1;
            color: #000;
            a{
              color: #036eb8;
            }
            a:hover{
               color: #036eb8;
               font-weight: bold;
               text-decoration: underline;
            }
          }
        }
      }
      .advert {
        width: 445px;
        height: 445px;
        margin: 0 auto;
        position: relative;
        @keyframes animtran {
          from {
            transform: rotateZ(0deg);
          }

          to {
            transform: rotateZ(360deg);
          }
        }

        @keyframes animtrans {
          from {
            transform: rotateZ(360deg);
          }

          to {
            transform: rotateZ(0deg);
          }
        }

        @-webkit-keyframes animtran {
          from {
            transform: rotateZ(0deg);
          }

          to {
            transform: rotateZ(360deg);
          }
        }

        @-webkit-keyframes animtrans {
          from {
            transform: rotateZ(360deg);
          }

          to {
            transform: rotateZ(0deg);
          }
        }
        .bg1 {
          width: 400px;
          height: 400px;
          position: absolute;
          top: 20px;
          left: 20px;
          z-index: 10;
          div {
            width: 400px;
            height: 400px;
            border: #2985c5 1px solid;
            border-radius: 15em;
            position: relative;
            animation: animtran 16s linear infinite;
            -webkit-animation: animtran 16s linear infinite;
            span {
              display: inline-block;
              width: 38px;
              height: 38px;
              border-radius: 50%;
              background: #036eb8;
              position: absolute;
              animation: animtrans 16s linear infinite;
              -webkit-animation: animtrans 16s linear infinite;
            }
            .icon01 {
              bottom: 80px;
              left: 7px;
            }
          }
        }
        .bg2 {
          width: 280px;
          height: 280px;
          position: absolute;
          top: 80px;
          left: 80px;
          z-index: 9;
          div {
            width: 280px;
            height: 280px;
            border: #036eb8 1px solid;
            border-radius: 15em;
            position: relative;
            animation: animtrans 12s linear infinite;
            -webkit-animation: animtrans 12s linear infinite;
            span {
              display: inline-block;
              overflow: hidden;
              position: absolute;
              animation: animtran 6s linear infinite;
              -webkit-animation: animtran 6s linear infinite;
              width: 22px;
              height: 22px;
              border-radius: 50%;
              background: #036eb8;
            }
            .icon08 {
              top: 10px;
              left: 55px;
            }
            .icon09 {
              bottom: 0;
              left: 75px;
            }
            .icon10 {
              bottom: 40px;
              right: 20px;
            }
          }
          img {
            display: block;
          }
        }
        .bg3 {
          width: 180px;
          height: 180px;
          position: absolute;
          top: 130px;
          left: 130px;
          z-index: 8;
          div {
            width: 180px;
            height: 180px;
            border: #036eb8 1px dotted;
            border-radius: 15em;
            position: relative;
            animation: animtran 8s linear infinite;
            -webkit-animation: animtran 8s linear infinite;
            span {
              display: inline-block;
              background-color: #ffffff;
              overflow: hidden;
              border-radius: 15em;
              position: absolute;
              animation: animtrans 4s linear infinite;
              -webkit-animation: animtrans 4s linear infinite;
            }
            .icon11 {
              top: 36px;
              right: 0px;
            }
            .icon12 {
              bottom: 25px;
              right: 10px;
            }
          }
        }
        .content {
          width: 130px;
          position: absolute;
          z-index: 11;
          left: 175px;
          top: 165px;
        }
      }
    }
  }
  /* company */
  .company {
    position: relative;
    .companybg1 {
      width: 346px;
      height: 584px;
      position: absolute;
      left: 0;
      top: -35px;
      background: url("./assets/images/Home/bg/line-01.png") no-repeat;
    }
    .companybg2 {
      width: 346px;
      height: 584px;
      position: absolute;
      right: 0;
      top: -35px;
      z-index: -1;
      background: url("./assets/images/Home/bg/line-02.png") no-repeat;
    }
    .company-content {
      width: 1040px;
      margin: 40px auto;
      .word {
        text-indent: 2em;
        text-align: left;
        line-height: 28px;
        padding: 0 50px;
        .more {
          text-align: right;
          color: #409eff;
          display: block;
          cursor: pointer;
        }
      }
      .status-title {
        font-size: 30px;
        text-align: center;
        margin-top: 20px;
        font-weight: 700;
      }
      .en-title {
        font-size: 18px;
        margin: 0 auto 10px;
        text-align: center;
        font-weight: 700;
      }
      .profile {
        & > div {
          width: 50%;
          display: inline-block;
          img {
            width: 100%;
          }
        }
      }
      .status {
        & > div {
          width: 50%;
          display: inline-block;
          img {
            width: 100%;
          }
          .list {
            li {
              text-align: left;
              line-height: 30px;
              text-align: center;
            }
          }
        }
      }
    }
  }
  /* partner */
  .partner {
    width: 100%;
    .img-list {
      width: 1040px;
      margin: 0 auto;
      padding: 40px 0;
      ul {
        li {
          display: inline-block;
          margin-right: 13px;
          float: left;
          margin-bottom: 13px;
          border: 1px solid #ccc;
          width: 133px;
          height: 77px;
        }
      }
    }
    .partner-title {
      text-align: center;
      margin: 15px auto;
      font-size: 30px;
      font-weight: 900;
    }
    .partner-other {
      position: relative;
      width: 400px;
      margin: 40px auto;
      border-bottom: 2px solid #ccc;
      .en-text {
        position: absolute;
        top: -24px;
        left: 68px;
        width: 265px;
        background: #fff;
        padding: 10px;
        font-size: 24px;
        text-align: center;
      }
    }
  }
  .Side-ad{
    position: fixed;
    right: 10px;
    top: 200px;
    z-index: 999;
    img {
      width:120px;
      height: auto;
    }
  }
}
</style>>
